@if (showDubbelzetter()) {
  <div
    class="font-default border-surface-300 text-surface-300 mx-1 inline-block h-full rounded-md border-3 border-dashed bg-purple-100/50 p-4 text-3xl font-bold select-none"
  >
    ■■
  </div>
} @else {
  <div
    class="font-default border-surface-300 mx-1 inline-block h-full rounded-md border-3 border-dashed bg-purple-100/50 p-4 text-3xl font-bold text-transparent select-none"
  >
    x
  </div>
}
